var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('i',{staticClass:"fe fe-user",class:_vm.$style.icon}),_c('strong',[_vm._v(" "+_vm._s(_vm.$store.state.user.name))])])])}
var staticRenderFns = []

export { render, staticRenderFns }